module.exports = __webpack_public_path__ + "img/remove-preview.502101d6.svg";